var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "viewer-xlsx" },
    [
      _vm.parsing
        ? _c("div", { staticClass: "viewer-xlsx__loading" }, [
            _vm._v("Carregando planilha..."),
          ])
        : _vm.sheetNames.length
        ? [
            _vm.sheetNames.length > 1
              ? _c(
                  "div",
                  { staticClass: "viewer-xlsx__tabs" },
                  _vm._l(_vm.sheetNames, function (name) {
                    return _c(
                      "button",
                      {
                        key: name,
                        staticClass: "viewer-xlsx__tab",
                        class: { "is-active": name === _vm.activeSheet },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.selectSheet(name)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(name) + " ")]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _c("div", {
              staticClass: "viewer-xlsx__table",
              domProps: { innerHTML: _vm._s(_vm.tableHtml) },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }